<template>
    <b-modal v-model="showModal" @hidden="fecharModal" size="xl" hide-footer
        :title="prefix + title">
        <ConsultarSolicitacaoAlteracaoValor :prefix="prefix" :ata="ata"></ConsultarSolicitacaoAlteracaoValor>

    </b-modal>
</template>

<script>

import ConsultarSolicitacaoAlteracaoValor from './ConsultarSolicitacaoAlteracaoValor.vue'

export default {
    components: {
        ConsultarSolicitacaoAlteracaoValor
    },
    props: {
        ata: {
            type: Number,
            default: null
        },
        prefix: {
            type: String,
            default: "",
        }
    },
    data() {
        return {
            title: "Consultar Solicitação de Alteração de Valor",
            showModal: true
        }
    },
    computed: {
    },
    methods: {
        fecharModal() {
            this.$emit('close')
        }
    },
    async beforeMount() {
    }
}
</script>
